import {Component, Input, OnInit} from '@angular/core';
// import {TASK_STATUS_MAP} from "../../../utils/statusUtil";

@Component({
  selector: 'pi-task-status-viewer',
  templateUrl: './task-status-viewer.component.html',
  styleUrls: ['./task-status-viewer.component.css']
})
export class TaskStatusViewerComponent implements OnInit {
  @Input() task: any;
 taskStatusMap = [];//TASK_STATUS_MAP;
  constructor() { }

  ngOnInit(): void {
  }

}
